module.exports = __webpack_public_path__ + "img/tlpa.11abb069.png";